document.addEventListener('DOMContentLoaded', function() {
  const firstToggleEl = document.querySelector('.product-description__link-for-frame-size');
  const secondToggleEl = document.querySelector('.product__frame-width-attribute');

  const modal = document.querySelector('.product-info-modal');
  const modalToggleBtn = document.querySelector('.product-info-modal__toggle');
  const modalBGOverlay = document.querySelector("info-modal-dialog");

  // bug with no hiding of header and promo banner
  const stickyHeader = document.querySelector('sticky-header');
  const stickyBar = document.getElementById('shopify-section-announcement-bar')

  function openModal() {

    //Something (probably LensAdvizor) overwrites the <body> tag application - changing to <html> instead
    const html = document.querySelector("html");
    html.classList.add("overflow-hidden");

      modal.setAttribute('open', '');

      // fix for not hiding headers
      stickyBar.style.display = 'none';
      stickyHeader.style.display = 'none';
  }

  function hide() {
    const html = document.querySelector("html");
    html.classList.remove("overflow-hidden");

    modal.removeAttribute('open'); 
    // fix for not hiding headers
    stickyBar.style.display = '';
    stickyHeader.style.display = '';
}

  // Add click event listeners
  if (firstToggleEl && stickyBar && stickyHeader){
    firstToggleEl.addEventListener('click', openModal);
  }
  if (secondToggleEl && stickyBar && stickyHeader){
    secondToggleEl.addEventListener('click', openModal);
  }

  if (modalToggleBtn){
    modalToggleBtn.addEventListener('click', hide);
  }

  if (modalBGOverlay){
    modalBGOverlay.addEventListener('click', hide);
  }

  // if click on ESC button
  document.addEventListener('keyup', function(event) {
      if (event.key === 'Escape') {
          hide();
      }
  });
});